import MasterItemCollection from './MasterItemCollection';

export class GradeMasterCollection {
  id:string;
  name:string;
  item_list:MasterItemCollection[] = [];

  /**
   * コンストラクタ
   */
  constructor(id:string, name:string ) {
    this.id = id;
    this.name = name;
  }

  /**
   * アイテム一覧の設定（最新マスタで上書き）
   */
  public updateItemList( list:any[] ):void{
    this.item_list = [];
    for ( let i:number = 0; i < list.length; i++ ){
      let master:MasterItemCollection = new MasterItemCollection( list[i] );
      this.item_list.push( master );
    }
  }

  /**
   * ２Dに対応するエンドアイテムの特定
   */
  getItemInfoForSymbol( id ):MasterItemCollection{
    let info = this.item_list.find((obj: MasterItemCollection) => obj.symbol_2d_code === id);
    if( !info ) return null;

    return info;
  }

  /**
   * ２Dに対応するエンドアイテムの特定
   */
  static getItemInfoForSymbolAndList( id, list ):MasterItemCollection{
    let info = list.find((obj: MasterItemCollection) => obj.symbol_2d_code === id);
    if( !info ) return null;

    return info;
  }

}
export default GradeMasterCollection;
